import React from "react";
import Box from "@mui/material/Box";
import Filter from "./Filter";
import CheckBox from "../../../components/CheckBox";
import { ReactComponent as AwardIcon } from "../../../assets/Icons/award.svg";
import { inperson, has_video } from "../../../constants/common";

const SessionsOfferedFilter = ({
  setFilters,
  filters,
  goBack = null,
  reset,
}) => {
  const handleCheckBox = (ev) => {
    const { name, checked } = ev.target;
    setFilters((prevState) => {
      const updatedState = { ...prevState };
      if (!checked) {
        delete updatedState[name];
      } else {
        updatedState[name] = 1;
      }
      return updatedState;
    });
  };

  return (
    <Filter
      label="Session Format"
      icon={<AwardIcon />}
      isRigntIcon={true}
      goBack={goBack}
      reset={reset}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1.5,
          overflow: "hidden",
        }}
      >
        <CheckBox
          label={inperson.label}
          name={inperson.value}
          onChange={handleCheckBox}
          checked={Boolean(filters?.inperson_session)}
        />
        <CheckBox
          label={has_video.label}
          name={has_video.value}
          onChange={handleCheckBox}
          checked={Boolean(filters?.has_video_provided)}
        />
      </Box>
    </Filter>
  );
};

export default SessionsOfferedFilter;
